
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleImageClick = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/programs');
    } else {
      window.location.href = '/programs';
    }
  };

  const handleAboutClick = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/about');
    } else {
      window.location.href = '/about';
    }
  };

  return (
    <section className="bg-[#FFF9F1] pt-24 pb-20 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 
            className={`text-4xl md:text-5xl lg:text-6xl font-bold text-[#2E5939] mb-6 transition-all duration-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ 
              fontFamily: '"Poppins", sans-serif',
              transitionDelay: '80ms'
            }}
          >
            Where The Journey of Life Begins
          </h1>
          
          <p 
            className={`text-xl text-[#2B2B2B]/80 mb-8 leading-relaxed max-w-3xl mx-auto transition-all duration-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ fontFamily: '"Open Sans", sans-serif', transitionDelay: '160ms' }}
          >
            At Creative Journeys, we believe early education should feel like an extension of home — warm, safe, and filled with developmental learning experiences. Our approach blends creativity, structure, and individualized care, which helps each child grow socially, emotionally, and academically.
          </p>
          
          <div 
            className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-500 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '240ms' }}
          >
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => {
                window.open('https://calendar.app.google/sG5oJhDdEq2U5GKn6', '_blank');
              }}
            >
              Schedule a Tour
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              onClick={() => {
                if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/about');
                } else {
                  window.location.href = '/about';
                }
              }}
            >
              Learn More About Us
            </Button>
          </div>

        </div>

        {/* Stacked Photo Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div 
            className={`transition-all duration-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '320ms' }}
          >
            <div 
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer h-full"
              onClick={handleImageClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleImageClick();
                }
              }}
              aria-label="Learn more about our Safe Learning Environment program"
            >
              <img 
                src="https://public.readdy.ai/ai/img_res/9559f7b434f5ea801dc23e5f01ad7259.jpg"
                alt="Children playing in daycare"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#2E5939] mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Nurturing Growth Through Play
                </h3>
                <p className="text-[#2B2B2B]/70" style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  We&apos;d love to show you around our facility and welcome you to our Family!
                </p>
              </div>
            </div>
          </div>

          <div 
            className={`transition-all duration-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '400ms' }}
          >
            <div 
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer h-full"
              onClick={handleAboutClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleAboutClick();
                }
              }}
              aria-label="Learn more about our Expert Care & Education program"
            >
              <img 
                src="https://readdy.ai/api/search-image?query=Caring%20daycare%20teacher%20reading%20a%20colorful%20storybook%20to%20a%20small%20group%20of%20attentive%20toddlers%20sitting%20in%20a%20circle%2C%20warm%20educational%20environment%2C%20nurturing%20atmosphere%2C%20cream%20and%20green%20tones&width=400&height=300&seq=hero2&orientation=landscape"
                alt="Teacher reading to children"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#2E5939] mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Expert Care & Education
                </h3>
                <p className="text-[#2B2B2B]/70" style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  We&apos;d love to show you around our facility and welcome you to our Family!
                </p>
              </div>
            </div>
          </div>

          <div 
            className={`transition-all duration-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '480ms' }}
          >
            <div 
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer h-full"
              onClick={handleImageClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleImageClick();
                }
              }}
              aria-label="Learn more about our Outdoor Adventures program"
            >
              <img 
                src="https://readdy.ai/api/search-image?query=Bright%20and%20welcoming%20daycare%20playground%20with%20children%20of%20different%20ages%20playing%20on%20safe%20colorful%20equipment%2C%20teachers%20supervising%2C%20outdoor%20learning%20environment%2C%20sunny%20day%2C%20natural%20green%20setting&width=400&height=300&seq=hero3&orientation=landscape"
                alt="Children playing outdoors"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#2E5939] mb-2" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Schedule A Tour or ENROLL NOW
                </h3>
                <p className="text-[#2B2B2B]/70" style={{ fontFamily: '"Open Sans", sans-serif' }}>
                  We&apos;d love to show you around our facility and welcome you to our Family!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
